<div *ngIf="selectSurvey && !emptySurvey" class="survey-detail-heading"> {{ 'SurveyDetails.selectSurvey' | translate }}
</div>
<div *ngIf="emptySurvey" class="survey-detail-heading">
        {{ 'SurveyList.noSurvey' | translate }}
</div>
<ul id="survey_detail_override_card_body">
    <li *ngIf="surveyDetailResponse" class="survey_detail_header_row breadcrumb-font" id="survey_breadcrumbs">
        <span style="color: #0079EF; cursor: pointer;"
            [routerLink]='["/home"]'>{{'SurveyDetails.home' | translate}}</span>
        <em class="fa fa-angle-right fa-lg px-1"></em>
        <span>{{'SurveyDetails.survey'| translate}}</span>
    </li>
</ul>
<div id="surveyTitleHeader" *ngIf="surveyDetailResponse">
    {{ surveyDetailResponse.surveyBasicInfo.surveyTitle }}
</div>
<div *ngIf="surveyDetailResponse" [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(surveyDetailResponse.description)">
</div>
<div class="col-lg-9 col-xl-10 col-md-9 col-xs-10 col-sm-10 col-10 mt-4 pl-0" *ngIf="relatedRequestResponse">
    <span class="zsd-cust-common-pageheading-font active">{{'SurveyDetails.relatedRequest' | translate}} </span>
</div>
<div class="related-request row"  *ngIf="relatedRequestResponse">
<div class="col-lg-6 col-md-6 col-sm-12">
    <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ ('CommonStrings.' + relatedRequestResponse.requestType) | translate}}# </label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestId }}</span>
    </div>
    <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{'SurveyDetails.closingTechnician' | translate}}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ relatedRequestResponse.closingTechnicianName }}</span>
    </div>
    <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{'SurveyDetails.slaAchieved' | translate}} </label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ ((relatedRequestResponse.slaAchieved)?'SurveyDetails.yes':'SurveyDetails.no') | translate   }}</span>
    </div>
</div>
<div class="col-lg-6 col-md-6 col-sm-12">
    <div class="mb-1 row" id="custom_row">
            <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{'SurveyDetails.openTime' | translate}}</label>
            <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ relatedRequestResponse.openTime }}</span>
    </div>
    <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{'SurveyDetails.closeTime' | translate}}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ relatedRequestResponse.closeTime }}</span>
    </div>
    <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{'SurveyDetails.description' | translate}}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ relatedRequestResponse.description }}</span>
    </div>
    <div *ngIf="relatedRequestResponse.solutionText && relatedRequestResponse.solutionText.length > 0" class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{'SurveyDetails.solution' | translate}}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ relatedRequestResponse.solutionText }}</span>
    </div>
</div>
</div>



<div class="cust_horizontal_rule_bottom"></div>
<div class="alert alert-danger" *ngIf="showErrorMessage" [ngClass]="showErrorMessage? 'showAlert':'hideAlert' ">
        <a class="close" style="cursor: pointer" (click)="closeAlert()">&times;</a>
        {{ 'SurveyDetails.errorMessage' | translate}}
    </div>
<form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <p *ngIf="surveyQuestionInfo">{{'SurveyDetails.responseDetails' | translate}}:</p>
    <div *ngFor="let survey of surveyQuestionInfo; let i = index" class="mb-3">

        <div class="row ml-0 mb-2" id="survey_questions">
            <span class="pr-2">{{i +1 }}.</span>
            <div [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(survey.description)">
                    
            </div>
            <span *ngIf="survey.required" id="mandatory_field" style="margin-left: 3px;"> *</span>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_AGREE_DISAGREE'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label"> {{ 'SurveyDetails.agree' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=0 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label"> {{ 'SurveyDetails.disagree' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=-1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label"> {{ 'SurveyDetails.undecided' | translate}}</label>
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_AGREE_DISAGREE_1_5'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=-3 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label" for="{{survey.answerTypeName}}{{ survey.surveryQsId }}">
                    {{ 'SurveyDetails.stronglyAgree' | translate}}</label></div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=-2 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label"> {{ 'SurveyDetails.agree' | translate}}</label></div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=-1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label"> {{ 'SurveyDetails.neutral' | translate}} </label></div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=0 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label"> {{ 'SurveyDetails.disagree' | translate}}</label></div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.stronglyDisagree' | translate}}</label></div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_SCALE_1_X'">

            <div class="slidecontainer">
                <input class="range range-slider" type="range" data-show-value="true" id="{{survey.surveryQsId}}"
                    data-popup-enabled="true" min="1" max="{{survey.scale}}" value="{{defaultScaleValue}}"  [(ngModel)]="scaleValue[survey.surveryQsId]"
                    formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId}}">
                <input readonly="true" *ngIf="scaleValue[survey.surveryQsId]" class="range-slider-output" value="{{scaleValue[survey.surveryQsId]}}" type="text"
                    autocomplete="off">
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_TEXT'">
            <div class="form-group">
                <textarea class="form-control" rows="5" id="comment"
                    formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}"></textarea>
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_TRUE_FALSE_UNDECIDED'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.true' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=0 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.false' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=-1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.undecided' | translate}}</label>
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_TRUE_FALSE'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.true' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=0 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.false' | translate}}</label>
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_YES_NO_BRANCH'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" value="1" formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.yes' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" value="0" formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.no' | translate}}</label>
            </div>
            <div *ngIf="!endSurvey"> ({{'SurveyDetails.jumptoQuestion'| translate}}{{ redirectToSurveyId }} ) </div>
            <div *ngIf="endSurvey"> ({{'SurveyDetails.endSurvey' | translate}} ) </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_YES_NO_UNDECIDED'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.yes' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=0 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.no' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=-1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.undecided' | translate}}</label>
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_YES_NO'">
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=1 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.yes' | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" [value]=0 formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}" type="radio">
                <label class="form-check-label">{{ 'SurveyDetails.no' | translate}}</label>
            </div>
        </div>
        <div *ngIf="survey.answerTypeName === 'RESPONSE_MENU'">
            <div class="col-md-7 col-lg-3 col-xl-3 pl-0">
                <select class="form-control custom-select" formControlName="{{survey.answerTypeName}}{{ survey.surveryQsId }}"
                    id="sd_item_category">
                    <option selected></option>
                    <option *ngFor="let response of survey.responses; let i = index" [value]="i">
                        {{ response }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="form-check" *ngIf="surveyDetailResponse && surveyDetailResponse.anonymousReply">
        <label class="form-check-label" for="anonymousReply">
            <input class="form-check-input" type="checkbox" value=""
                formControlName="anonymousReply">{{'SurveyDetails.anonymousReply' | translate}}
        </label>
    </div>
    <div class="form-group float-right" *ngIf="surveyDetailResponse">
        <button class="btn zsd_button" id="zsd_cust_button_create"
            type="submit">{{'SurveyDetails.submitButton' | translate}}</button>
    </div>
</form>